<ng-container *ngIf="vm$ | async as vm; else status">
    <main class="profile-content">
      <mat-tab-group animationDuration="0ms" [mat-stretch-tabs]="false" [fitInkBarToContent]="true" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="rememberSelectedTab($event)">
        <mat-tab label="Resumen">
          <div class="tab-content">
            <div class="cards-grid summary-grid">
              <div class="card-column">
                <ng-container *ngTemplateOutlet="contact"></ng-container>
                <ng-container *ngTemplateOutlet="events; context: { eventLimit: 3 }"></ng-container>
              </div>
              <div class="card-column">
                <ng-container *ngTemplateOutlet="activitySummary; context: { $implicit: vm.activity.categories }"></ng-container>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Info personal">
          <div class="tab-content">
            <div class="cards-grid personal-grid">
              <div class="card-column">
                <app-detail-card title="Identificación" icon="person_outline">
                  <dl class="personal-info-list">
                    <div class="personal-info-item">
                      <dt>Nombre completo:</dt>
                      <dd>{{ getFullName(vm.person) }}</dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Documento:</dt>
                      <dd>{{ getDocumentInfo(vm.person) }}</dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Género:</dt>
                      <dd>{{ getGenderLabel(vm.person) }}</dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Ocupación:</dt>
                      <dd>{{ getPersonalInfoValue(vm.person.occupation) }}</dd>
                    </div>
                    <div class="personal-info-item personal-info-item--wide">
                      <dt>Religión previa:</dt>
                      <dd>{{ getPersonalInfoValue(vm.person.previousReligion) }}</dd>
                    </div>
                  </dl>
                </app-detail-card>
                <app-detail-card title="Nacimiento" icon="cake">
                  <dl class="personal-info-list">
                    <div class="personal-info-item">
                      <dt>Fecha de nacimiento:</dt>
                      <dd>{{ getBirthDateInfo(vm.person, vm.age) }}</dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Lugar de nacimiento:</dt>
                      <dd>{{ getPersonalInfoValue(vm.person.placeOfBirth) }}</dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>País de nacimiento:</dt>
                      <dd>{{ getPersonalInfoValue(vm.person.countryOfBirthName) }}</dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Nacionalidad:</dt>
                      <dd>{{ getPersonalInfoValue(vm.person.nationalityName) }}</dd>
                    </div>
                  </dl>
                </app-detail-card>
              </div>
              <div class="card-column">
                <app-detail-card title="Información de contacto" icon="phone">
                  <dl class="personal-info-list">
                    <div class="personal-info-item personal-info-item--wide">
                      <dt>Email:</dt>
                      <dd class="personal-info-action-value">
                        <span>{{ getPersonalInfoValue(vm.person.email) }}</span>
                        <a *ngIf="vm.person.email" [href]="getMailToUrl(vm.person)" class="personal-info-icon-link" matTooltip="Enviar mail" aria-label="Enviar mail a esta dirección">
                          <mat-icon>mail</mat-icon>
                        </a>
                      </dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Teléfono:</dt>
                      <dd>{{ getPersonalInfoValue(vm.person.phone | phoneNumber) }}</dd>
                    </div>
                    <div class="personal-info-item personal-info-item--wide">
                      <dt>Dirección:</dt>
                      <dd class="personal-info-action-value">
                        <span>{{ getPersonalInfoValue(vm.person.address) }}</span>
                        <a *ngIf="vm.person.address" [href]="getGoogleMapsUrl(vm.person)" target="_blank" rel="noopener" class="personal-info-icon-link" matTooltip="Ver en maps" aria-label="Ver dirección en Google Maps">
                          <mat-icon>map</mat-icon>
                        </a>
                      </dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Idiomas:</dt>
                      <dd>{{ getPersonalInfoValue(vm.person.languages) }}</dd>
                    </div>
                  </dl>
                </app-detail-card>
                <app-detail-card title="Vínculos personales" icon="diversity_1">
                  <ng-container card-actions>
                    <button *ngIf="canManageMemberData$ | async" mat-icon-button type="button" matTooltip="Editar vínculos familiares" aria-label="Editar vínculos familiares" (click)="navigateToFamilyRelationships()">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>
                  <dl class="personal-info-list">
                    <div class="personal-info-item">
                      <dt>Situación de pareja:</dt>
                      <dd>
                        {{ getRelationshipSituationLabel(vm.person) }}
                        <app-member-reference *ngIf="vm.person.relationshipSituation !== 'Divorced' && vm.person.relationshipSituation !== 'Unspecified' && vm.person.relationshipPersonName" [personId]="vm.person.relationshipPersonId" [name]="vm.person.relationshipPersonName"></app-member-reference>
                      </dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Padres:</dt>
                      <dd>
                        <ng-container *ngIf="vm.familyRelationships.parents.length; else noParents">
                          <app-member-reference *ngFor="let relationship of vm.familyRelationships.parents" [personId]="relationship.relatedPersonId" [name]="relationship.relatedPersonName" [isDeceased]="relationship.isRelatedPersonDeceased ?? false"></app-member-reference>
                        </ng-container>
                        <ng-template #noParents>
                          -
                        </ng-template>
                      </dd>
                    </div>
                    <div class="personal-info-item">
                      <dt>Hijos:</dt>
                      <dd>
                        <ng-container *ngIf="vm.familyRelationships.children.length; else noChildren">
                          <app-member-reference *ngFor="let relationship of vm.familyRelationships.children" [personId]="relationship.relatedPersonId" [name]="relationship.relatedPersonName" [isDeceased]="relationship.isRelatedPersonDeceased ?? false"></app-member-reference>
                        </ng-container>
                        <ng-template #noChildren>
                          -
                        </ng-template>
                      </dd>
                    </div>
                  </dl>
                </app-detail-card>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Asistencia espiritual">
          <div class="tab-content">
            <app-detail-card title="Comunidad de pertenencia" icon="church" class="community-card" [scrollable]="false">
              <div class="community-heading">
                <a class="community-link" [routerLink]="['/units', vm.person.communityId]">{{ vm.person.communityName || 'Sin comunidad' }}</a>
                <nav *ngIf="vm.communityAncestors.length" class="community-hierarchy" aria-label="Unidades superiores">
                  <ng-container *ngFor="let unit of vm.communityAncestors; let last = last">
                    <a [routerLink]="['/units', unit.id]">{{ unit.name }}</a>
                    <span *ngIf="!last" aria-hidden="true"> / </span>
                  </ng-container>
                </nav>
                <app-membership-status-badge [status]="vm.person.status"></app-membership-status-badge>
              </div>
              <section class="pastoral-care-card__section responsible-priest-row">
                <span class="pastoral-care-card__label">Pastor de hogar:</span>
                <app-member-reference *ngIf="vm.person.responsiblePriestId; else noResponsiblePriest" [personId]="vm.person.responsiblePriestId" [name]="vm.person.responsiblePriestName || 'Pastor de hogar'" [matTooltip]="vm.person.responsiblePriestName || 'Pastor de hogar'"></app-member-reference>
                <ng-template #noResponsiblePriest>
                  <span class="pastoral-care-card__empty">Sin asignar</span>
                </ng-template>
                <button *ngIf="canManageMemberData$ | async" mat-icon-button type="button" class="pastoral-care-card__action pastoral-care-card__action--icon" [matTooltip]="vm.person.responsiblePriestId ? 'Modificar pastor de hogar' : 'Asignar pastor de hogar'" [attr.aria-label]="vm.person.responsiblePriestId ? 'Modificar pastor de hogar' : 'Asignar pastor de hogar'" (click)="manageResponsiblePriest(vm.person)">
                  <mat-icon>{{ vm.person.responsiblePriestId ? 'edit' : 'person_add' }}</mat-icon>
                </button>
              </section>
            </app-detail-card>
            <div class="cards-grid spiritual-grid">
              <app-detail-card title="VAE" subtitle="Visita de asistencia espiritual" icon="home">
                <ng-container card-actions>
                  <button *ngIf="canManageMemberData$ | async" mat-icon-button type="button" aria-label="Agregar VAE" matTooltip="Agregar VAE" [routerLink]="['/units', vm.person.communityId, 'spiritual-assistance-visits', 'new']" [queryParams]="{ recipientId: vm.person.id }">
                    <mat-icon>add</mat-icon>
                  </button>
                </ng-container>
                <div class="visit-summary" *ngIf="getLastSpiritualAssistanceVisit(vm) as lastVisit; else noVisits">
                  <span class="pastoral-care-card__label">Última visita registrada</span>
                  <strong class="visit-summary__date">{{ getVisitDateLabel(lastVisit) }}</strong>
                  <span class="visit-summary__age">{{ getVisitDaysAgoLabel(lastVisit) }}</span>
                  <div class="visit-summary__details">
                    <span><span class="pastoral-care-card__label">Lugar:</span> {{ getVisitLocation(lastVisit) }} · {{ lastVisit.organizationUnitName }}</span>
                    <div>
                      <span class="pastoral-care-card__label">Asistentes espirituales</span>
                      <ul *ngIf="lastVisit.visitors.length; else noVisitors">
                        <li *ngFor="let visitor of lastVisit.visitors"><a class="visit-summary__visitor-link" [routerLink]="['/people', visitor.id]">{{ visitor.fullName }}</a></li>
                      </ul>
                      <ng-template #noVisitors><span class="visit-summary__muted">Sin asistentes registrados</span></ng-template>
                    </div>
                    <span *ngIf="lastVisit.holyCommunionDelivered" class="visit-summary__communion"><mat-icon>local_cafe</mat-icon> Se dio Santa Cena</span>
                  </div>
                  <div class="previous-visits">
                    <h4>Anteriores</h4>
                    <div *ngIf="getPreviousSpiritualAssistanceVisits(vm).length; else noPreviousVisits" class="previous-visits__list">
                      <div class="previous-visits__item" *ngFor="let visit of getPreviousSpiritualAssistanceVisits(vm)">
                        <mat-icon>chevron_right</mat-icon>
                        <span>{{ getVisitDateLabel(visit) }}</span>
                        <mat-icon *ngIf="visit.holyCommunionDelivered" class="previous-visits__communion" matTooltip="Se dio Santa Cena">local_cafe</mat-icon>
                      </div>
                    </div>
                    <ng-template #noPreviousVisits><p class="visit-summary__muted">No hay visitas anteriores.</p></ng-template>
                  </div>
                </div>
                <ng-template #noVisits>
                  <div class="section-empty-state"><mat-icon>event_busy</mat-icon><div><strong>Sin VAE registradas</strong><span>Las visitas de asistencia espiritual aparecerán aquí.</span></div></div>
                  <div class="previous-visits"><h4>Anteriores</h4><p class="visit-summary__muted">No hay visitas anteriores.</p></div>
                </ng-template>
              </app-detail-card>
              <app-detail-card title="Concurrencia" subtitle="Concurrencia a los Servicios Divinos" icon="church">
                <div class="attendance-overview">
                  <section class="attendance-overview__last">
                    <span class="pastoral-care-card__label">Última concurrencia registrada</span>
                    <ng-container *ngIf="getLastDivineServiceAttendance(vm) as lastAttendance; else noAttendance">
                      <strong class="attendance-overview__date">{{ getDivineServiceDateLabel(lastAttendance.startAt) }}</strong>
                      <span class="attendance-overview__age">{{ getAttendanceDaysAgoLabel(lastAttendance) }}</span>
                      <span class="attendance-overview__service">{{ lastAttendance.divineServiceTypeName }} · {{ lastAttendance.organizationUnitName }}</span>
                    </ng-container>
                    <ng-template #noAttendance><span class="visit-summary__muted">Sin concurrencias registradas.</span></ng-template>
                  </section>
                  <section class="attendance-overview__period">
                    <span class="pastoral-care-card__label">Últimas 4 semanas</span>
                    <strong class="attendance-overview__count">{{ getAttendedDivineServiceCount(vm) }} de {{ vm.recentDivineServices.length }} <small>Servicios Divinos</small></strong>
                    <span class="attendance-overview__percentage">{{ getAttendancePercentage(vm) }}% de concurrencia</span>
                  </section>
                </div>
                <section class="recent-services">
                  <div class="recent-services__heading"><span class="pastoral-care-card__label">Últimos servicios divinos</span><span>{{ getDivineServiceRangeLabel(vm) }}</span></div>
                  <div *ngIf="vm.recentDivineServices.length; else noRecentServices" class="recent-services__timeline" role="group" aria-label="Últimos servicios divinos">
                    <button *ngFor="let service of vm.recentDivineServices" type="button" class="recent-service" [class.recent-service--present]="isPersonPresentAtDivineService(vm, service)" [class.recent-service--absent]="!isPersonPresentAtDivineService(vm, service)" [class.recent-service--selected]="getSelectedDivineService(vm)?.id === service.id" [attr.aria-pressed]="getSelectedDivineService(vm)?.id === service.id" [attr.aria-label]="getDivineServiceDateLabel(service.startAt) + (isPersonPresentAtDivineService(vm, service) ? ', presente' : ', ausente')" (click)="selectDivineService(service.id)">
                      <span class="recent-service__square"><mat-icon>{{ isPersonPresentAtDivineService(vm, service) ? 'check' : 'close' }}</mat-icon></span>
                      <span>{{ getDivineServiceDateLabel(service.startAt, { day: 'numeric', month: 'short' }) }}</span>
                    </button>
                  </div>
                  <ng-template #noRecentServices><div class="section-empty-state section-empty-state--compact"><mat-icon>event_busy</mat-icon><span>No hay servicios divinos en las últimas 4 semanas.</span></div></ng-template>
                  <div *ngIf="getSelectedDivineService(vm) as selectedService" class="selected-service">
                    <div class="selected-service__details">
                      <strong>{{ getDivineServiceDateLabel(selectedService.startAt, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) }}</strong>
                      <span>{{ selectedService.bibleText || selectedService.notes || 'Sin texto registrado' }}</span>
                    </div>
                    <span class="selected-service__attendance" [class.selected-service__attendance--present]="isPersonPresentAtDivineService(vm, selectedService)" [class.selected-service__attendance--absent]="!isPersonPresentAtDivineService(vm, selectedService)">{{ isPersonPresentAtDivineService(vm, selectedService) ? 'Presente' : 'Ausente' }}</span>
                  </div>
                </section>
              </app-detail-card>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="hasMinisterialActivity(vm)" label="Actividad ministerial">
          <div class="tab-content">
            <ng-container *ngTemplateOutlet="ministryActivity"></ng-container>
            <div class="cards-grid ministry-grid">
              <app-detail-card *ngIf="vm.person.ministry?.status === 'Active'" title="Miembros confiados" icon="groups" [isEmpty]="!vm.trustedMembers.length" emptyMessage="Sin miembros confiados.">
                <div class="detail-list">
                  <button type="button" class="detail-list-item" *ngFor="let item of vm.trustedMembers | slice:trustedMembersPageIndex * 5:(trustedMembersPageIndex + 1) * 5" (click)="navigateToPerson(item.id)">
                    <div class="trusted-member-row">
                      <span class="trusted-member-row__name">{{ item.firstName }} {{ item.lastName }}</span>
                      <span class="trusted-member-row__phone">
                        <mat-icon>phone</mat-icon>
                        {{ item.phone ? (item.phone | phoneNumber) : 'Sin teléfono' }}
                      </span>
                      <span *ngIf="shouldShowTrustedMemberCommunity(vm.person)" class="trusted-member-row__community">
                        <mat-icon>church</mat-icon>
                        {{ item.membershipUnitName || 'Sin comunidad' }}
                      </span>
                    </div>
                  </button>
                </div>
                <mat-paginator card-footer *ngIf="vm.trustedMembers.length > 5" [length]="vm.trustedMembers.length" [pageIndex]="trustedMembersPageIndex" [pageSize]="5" [hidePageSize]="true" (page)="trustedMembersPageIndex = $event.pageIndex">
                </mat-paginator>
              </app-detail-card>
              <ng-container *ngTemplateOutlet="ministerialEvents"></ng-container>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Colaboración">
          <div class="tab-content">
            <div class="collaboration-grid">
              <ng-container *ngTemplateOutlet="activitySummary; context: { $implicit: getCollaborationActivityCategories(vm) }"></ng-container>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Historial">
          <div class="tab-content">
            <div class="cards-grid">
              <app-detail-card title="Pases de comunidad" icon="swap_horiz" [isEmpty]="!getRecentCommunities(vm).length" emptyMessage="Sin historial de comunidades registrado.">
                <button card-actions mat-icon-button type="button" class="card-header-action" matTooltip="Ver historial de pases" aria-label="Ver historial de pases" (click)="navigateToCommunityHistory()">
                  <mat-icon>open_in_new</mat-icon>
                </button>
                <div class="detail-list">
                  <button type="button" class="detail-list-item" *ngFor="let item of getRecentCommunities(vm)" (click)="navigateToUnit(item.organizationUnitId)">
                    <div class="recent-community">
                      <span class="recent-community__date">{{ formatCommunityDate(item) }}</span>
                      <span class="recent-community__name">{{ item.organizationUnitName }}</span>
                    </div>
                  </button>
                </div>
              </app-detail-card>
              <ng-container *ngTemplateOutlet="events; context: { eventLimit: 5 }"></ng-container>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </main>
  <ng-template #contact>
    <app-detail-card title="Información de contacto" icon="phone">
      <dl class="info-list">
        <div>
          <dt>Email:</dt>
          <dd>
            <a *ngIf="vm.person.email; else noEmail" [href]="getMailToUrl(vm.person)">
              {{ vm.person.email }}
            </a>
            <ng-template #noEmail>
              -
            </ng-template>
          </dd>
          <a *ngIf="vm.person.email" [href]="getMailToUrl(vm.person)" class="contact-action" aria-label="Enviar mail" matTooltip="Enviar mail">
            <mat-icon>mail_outline</mat-icon>
          </a>
        </div>
        <div>
          <dt>Teléfono:</dt>
          <dd>{{ getPersonalInfoValue(vm.person.phone | phoneNumber) }}</dd>
          <a *ngIf="vm.person.phone" [href]="'tel:' + vm.person.phone" class="contact-action" aria-label="Llamar por teléfono" matTooltip="Llamar">
            <mat-icon>phone</mat-icon>
          </a>
        </div>
        <div>
          <dt>Dirección:</dt>
          <dd>{{ getPersonalInfoValue(vm.person.address) }}</dd>
          <a *ngIf="vm.person.address" [href]="getGoogleMapsUrl(vm.person)" target="_blank" rel="noopener" class="contact-action" aria-label="Ver dirección en Google Maps" matTooltip="Ver en Maps">
            <mat-icon>map</mat-icon>
          </a>
        </div>
      </dl>
    </app-detail-card>
  </ng-template>
  <ng-template #activitySummary let-categories>
    <app-detail-card title="Actividad actual" icon="work_outline" [isEmpty]="categories.length === 0" emptyMessage="Sin actividad actual registrada.">
      <dl class="activity-summary">
        <div *ngFor="let category of categories" class="activity-summary-category">
          <dt>{{ category.label }}</dt>
          <dd>
            @if (category.label === 'Ministerio') {
              <div class="activity-summary-item">
                <ng-container *ngTemplateOutlet="summaryActivityItem; context: { $implicit: category.items[0] }"></ng-container>
              </div>
            } @else {
              <ul class="activity-summary-list">
                <li *ngFor="let item of getActivitySummaryItems(category)">
                  <div class="activity-summary-item">
                    <ng-container *ngTemplateOutlet="summaryActivityItem; context: { $implicit: item }"></ng-container>
                  </div>
                </li>
              </ul>
            }
          </dd>
        </div>
      </dl>
    </app-detail-card>
  </ng-template>
  <ng-template #summaryActivityItem let-item>
      <span>{{ item.name }}</span>
      <app-ministry-status-badge *ngIf="item.ministryStatus && item.ministryStatus !== 'Active'" [status]="item.ministryStatus"></app-ministry-status-badge>
      <span *ngIf="item.ministryActivityUnits?.length" class="activity-summary-areas">(<ng-container *ngFor="let unit of item.ministryActivityUnits; let last = last"><a *ngIf="unit.id; else activityUnitName" [routerLink]="['/units', unit.id]">{{ unit.name }}</a><ng-template #activityUnitName>{{ unit.name }}</ng-template>{{ last ? '' : ', ' }}</ng-container>)</span>
      <span *ngIf="item.typeLabel !== 'Ministerio' && item.summaryUnits?.length" class="activity-summary-areas">(<ng-container *ngFor="let unit of item.summaryUnits; let last = last"><a *ngIf="unit.id; else summaryUnitName" [routerLink]="['/units', unit.id]">{{ unit.name }}</a><ng-template #summaryUnitName>{{ unit.name }}</ng-template>{{ last ? '' : ', ' }}</ng-container>)</span>
      <span *ngIf="item.detail" class="activity-summary-detail">{{ item.detail }}</span>
  </ng-template>
  <ng-template #ministryActivity>
    <app-detail-card title="Actividad actual" icon="work_outline" class="current-activity-card" [isEmpty]="!getMinistryActivityLines(vm).length" emptyMessage="Sin actividad ministerial actual registrada.">
      <ul class="activity-summary-list">
        <li class="activity-summary-item" *ngFor="let line of getMinistryActivityLines(vm)">
          <span>{{ line.activities.join(', ') }}<ng-container *ngIf="line.units.length"> en <ng-container *ngFor="let unit of line.units; let last = last"><a *ngIf="unit.id; else ministryActivityUnitName" [routerLink]="['/units', unit.id]">{{ unit.name }}</a><ng-template #ministryActivityUnitName>{{ unit.name }}</ng-template>{{ last ? '' : ', ' }}</ng-container></ng-container></span>
          <app-ministry-status-badge *ngIf="line.ministryStatus && line.ministryStatus !== 'Active'" [status]="line.ministryStatus"></app-ministry-status-badge>
        </li>
      </ul>
    </app-detail-card>
  </ng-template>
  <ng-template #events let-eventLimit="eventLimit">
    <app-detail-card title="Últimos eventos" icon="history" [isEmpty]="getFilteredTimelineItems(vm).length === 0" emptyMessage="Sin eventos cargados por el momento.">
      <div card-actions>
        <button mat-icon-button type="button" class="card-header-action" [matMenuTriggerFor]="timelineFilters" matTooltip="Filtrar eventos" aria-label="Filtrar eventos">
          <mat-icon>filter_list</mat-icon>
        </button>
        <button mat-icon-button type="button" class="card-header-action" matTooltip="Ver todo el historial" aria-label="Ver todo el historial" (click)="navigateToEvents()">
          <mat-icon>open_in_new</mat-icon>
        </button>
        <mat-menu #timelineFilters="matMenu">
          <button mat-menu-item *ngFor="let category of filterOptions" (click)="toggleTimelineFilter(category.value)">
            <mat-icon>{{ activeFilters.includes(category.value) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            <span>{{ category.label }}</span>
          </button>
        </mat-menu>
      </div>
      <div class="milestone-timeline milestone-timeline--clean">
        <button type="button" class="milestone-timeline__item" *ngFor="let item of getFilteredTimelineItems(vm) | slice:0:eventLimit" [matTooltip]="item.title" matTooltipPosition="above" (click)="navigateToEvents()">
          <span class="milestone-timeline__marker" [class]="'milestone-timeline__marker milestone-timeline__marker--' + item.theme"> </span>
          <span>
            <span class="milestone-timeline__meta">
              <span class="milestone-timeline__date">{{ item.date | date:'dd/MM/yyyy' }}</span>
              <span class="milestone-timeline__category" [class]="'milestone-timeline__category milestone-timeline__category--' + item.theme">{{ item.categoryLabel }}</span>
            </span>
            <span class="milestone-timeline__event-line">
              <span class="milestone-timeline__title">{{ item.title }}</span>
              <span class="milestone-timeline__detail milestone-timeline__event-type" *ngIf="item.detail">{{ item.detail }}</span>
            </span>
          </span>
        </button>
      </div>
    </app-detail-card>
  </ng-template>
  <ng-template #ministerialEvents>
    <app-detail-card title="Historial de actividad ministerial" icon="history" [isEmpty]="getMinisterialTimelineItems(vm).length === 0" emptyMessage="Sin eventos cargados por el momento.">
      <div card-actions>
        <button mat-icon-button type="button" class="card-header-action" matTooltip="Ver todo el historial" aria-label="Ver todo el historial" (click)="navigateToEvents()">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
      <div class="milestone-timeline milestone-timeline--clean">
        <button type="button" class="milestone-timeline__item" *ngFor="let item of getMinisterialTimelineItems(vm) | slice:0:5" [matTooltip]="item.title" matTooltipPosition="above" (click)="navigateToEvents()">
          <span class="milestone-timeline__marker" [class]="'milestone-timeline__marker milestone-timeline__marker--' + item.theme"> </span>
          <span>
            <span class="milestone-timeline__meta">
              <span class="milestone-timeline__date">{{ item.date | date:'dd/MM/yyyy' }}</span>
            </span>
            <span class="milestone-timeline__event-line">
              <span class="milestone-timeline__title">{{ item.title }}</span>
              <span class="milestone-timeline__detail milestone-timeline__event-type" *ngIf="item.detail">{{ item.detail }}</span>
              <span class="milestone-timeline__detail" *ngIf="item.areas.length">(<ng-container *ngFor="let area of item.areas; let last = last"><a *ngIf="area.id; else ministerialTimelineAreaName" [routerLink]="['/units', area.id]">{{ area.name }}</a><ng-template #ministerialTimelineAreaName>{{ area.name }}</ng-template>{{ last ? '' : ', ' }}</ng-container>)</span>
            </span>
          </span>
        </button>
      </div>
    </app-detail-card>
  </ng-template>
</ng-container>
<ng-template #status>
  <div *ngIf="loadError; else loading" class="person-access-error" role="alert">
    <mat-icon>lock</mat-icon>
    <h2>No se pudo cargar la ficha</h2>
    <p>{{ loadError }}</p>
  </div>
</ng-template>
<ng-template #loading>
  <div class="loading-container">
    <mat-spinner>
    </mat-spinner>
  </div>
</ng-template>
